import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { Modal } from "../../atoms/modals/antd-modals";
import { Button } from "../../atoms/buttons/buttons";
import { TimePicker } from "antd";
import Form from "antd/es/form";
import "antd/es/form/style";
import styles from "./style.module.scss";
import shiftApi from "../../../utilities/api/shift";
import openNotification from "../../../utilities/openNotification";
import FeatherIcon from "feather-icons-react";
import { get, isEmpty } from "lodash";

function BreakModalEdit(props) {
    const [form] = Form.useForm();
    const [modalVisible, setModalVisible] = React.useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const { showEditBreakModal,
        breakObj,
        setShowEditBreakModal,
        slotOptions,
        refetch,
        refetchWaivableFees,
        setIsLoading,
        location_id,
        session_date,
        apptRange,
        break_minutes
    } = props;

    useEffect(() => {
        setSelectedTime("");
        form.setFieldsValue({
            "start-time": "",
        });
        setModalVisible(showEditBreakModal);
    }, [showEditBreakModal])


    const breakModal = () => {
        if (!modalVisible) return null;
        return <Modal
            className="no-lines-modal"
            closable={true}
            centered
            visible={modalVisible}
            onCancel={() => {
                setShowEditBreakModal(false);
            }}
            title={<div className="color-dark">Move Break</div>}
            footer={[
                {
                    size: "large",
                    type: "primary",
                    text: "Move Break >",
                    style: {
                        fontSize: "14px",
                        lineHeight: "16px"
                    },
                    onClick: onSubmit,
                    disabled: !selectedTime
                },
            ].map((button, index) => (
                <Button
                    className={button.className}
                    key={`brk-modal-btn-${index}`}
                    size={button.size}
                    type={button.type}
                    outlined={button.outlined}
                    onClick={button.onClick}
                    style={button.style}
                    disabled={button.disabled}
                >
                    {button.text}
                </Button>
            ))}
        >
            <p>Please choose a time slot.</p>
            <Form
                form={form}
                name="reasons"
                onFinish={(e) => e?.preventDefault()}
                layout="vertical"
            >
                <Form.Item
                    colon={false}
                    name="start-time"
                    label="Start Time"
                    rules={[{ required: true, message: "Start time is required!" }]}
                >
                    <TimePicker
                        className={styles["select_handler"]}
                        popupClassName={styles["time-picker-popup"]}
                        suffixIcon={
                            <FeatherIcon icon="clock" size={16} color="#586B94" />
                        }
                        use12Hours
                        allowClear={false}
                        onSelect={(time) => {
                            // Convert selected time to appointment's timezone to avoid timezone mismatch
                            const selectedInApptTz = apptRange.start.clone().set({
                                hour: moment(time).hour(),
                                minute: moment(time).minute(),
                                second: 0,
                                millisecond: 0
                            });
                            setSelectedTime(selectedInApptTz);
                            form.setFieldsValue({
                                "start-time": moment(time),
                            });
                        }}
                        minuteStep={5}
                        inputReadOnly
                        format="h:mm A"
                        showNow={false}
                        initialValues={selectedTime}
                        disabledTime={() => {
                            if (!apptRange || !apptRange.start || !apptRange.end) {
                                return {};
                            }
                            
                            const disabledHours = () => {
                                const hours = [];
                                const startHour = moment(apptRange.start).hour();
                                const endHour = moment(apptRange.end).hour();
                                for (let i = 0; i < startHour; i++) {
                                    if (i < startHour || i > endHour) {
                                        hours.push(i);
                                    }
                                }
                                for (let i = endHour + 1; i < 24; i++) {
                                    hours.push(i);
                                }
                                return hours;
                            }

                            const disabledMinutes = (selectedHour) => {
                                const minutes = [];
                                const startMinute = moment(apptRange.start).minute();
                                const endMinute = moment(apptRange.end).minute();
                                const breakLength = breakObj?.currentLength || break_minutes || 0;
                                
                                // Disable minutes before shift start
                                if (selectedHour === moment(apptRange.start).hour()) {
                                    for (let i = 0; i < startMinute; i += 5) {
                                        minutes.push(i);
                                    }
                                }
                                
                                // Calculate the latest allowed start time considering break length
                                const latestStartTime = moment(apptRange.end).subtract(breakLength, 'minutes');
                                
                                // Disable minutes after the latest allowed start time
                                if (selectedHour === moment(apptRange.end).hour()) {
                                    // If the latest start time is in an earlier hour, disable all minutes
                                    if (latestStartTime.hour() < selectedHour) {
                                        for (let i = 0; i < 60; i += 5) {
                                            minutes.push(i);
                                        }
                                    } else {
                                        // Disable minutes after the latest allowed start time
                                        for (let i = latestStartTime.minute() + 5; i < 60; i += 5) {
                                            minutes.push(i);
                                        }
                                    }
                                } else if (selectedHour === latestStartTime.hour() && selectedHour !== moment(apptRange.end).hour()) {
                                    // If latest start time hour is different from end hour, handle that hour too
                                    for (let i = latestStartTime.minute() + 5; i < 60; i += 5) {
                                        minutes.push(i);
                                    }
                                }
                                
                                // Disable minutes that would overlap with other existing breaks
                                // Allow adjacent breaks (one ends when another starts)
                                const otherBreaks = breakObj?.otherBreaks || [];
                                otherBreaks.forEach((otherBreak) => {
                                    const otherBreakStart = moment(`${session_date} ${otherBreak.start_time}`, "YYYY-MM-DD h:mm A");
                                    const otherBreakEnd = moment(`${session_date} ${otherBreak.end_time}`, "YYYY-MM-DD h:mm A");
                                    
                                    // Check if the selected hour is within the range of this other break
                                    for (let i = 0; i < 60; i += 5) {
                                        const testTime = moment(apptRange.start).set({
                                            hour: selectedHour,
                                            minute: i
                                        });
                                        const testEndTime = testTime.clone().add(breakLength, 'minutes');
                                        
                                        // Check for actual overlap (not just adjacency)
                                        // Breaks overlap if: testTime < otherBreakEnd AND testEndTime > otherBreakStart
                                        // But we allow adjacent: testTime == otherBreakEnd OR testEndTime == otherBreakStart
                                        const hasOverlap = testTime.isBefore(otherBreakEnd) && testEndTime.isAfter(otherBreakStart);
                                        
                                        // Only disable if there's actual overlap (adjacent breaks are fine)
                                        if (hasOverlap) {
                                            if (!minutes.includes(i)) {
                                                minutes.push(i);
                                            }
                                        }
                                    }
                                });
                                
                                return minutes;
                            }

                            return {
                                disabledHours,
                                disabledMinutes
                            };
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    }
    const onSubmit = () => {
        if (!selectedTime || isEmpty(apptRange)) return;
        
        // selectedTime is already in the appointment's timezone
        if (selectedTime.isBefore(apptRange.start) || selectedTime.isAfter(apptRange.end)) {
            openNotification("Error", "Selected time is out of appointment range.", "error");
            return;
        }

        setIsLoading(true);
        shiftApi.editBreakInSlot({
            location_id,
            session_date: session_date,
            session_time: selectedTime.format("h:mm A"),
            session_end_time: selectedTime.clone().add(breakObj?.currentLength, "minutes").format("h:mm A"),
            slot_id: breakObj.id,
        }).then((res) => {
            setIsLoading(false);
            openNotification("Success", res.data.message, "success");
            refetch();
            refetchWaivableFees();
            setShowEditBreakModal(false);
        }).catch((err) => {
            setIsLoading(false);
            openNotification("Error", get(err, "response.data.error", ""), "error");
        });
    }
    return (
        <div>
            {breakModal()}
        </div>
    )
}
export default BreakModalEdit;